import React, { useContext, useState } from 'react'
import { Link } from 'react-router-dom'
import useTemplateHook from '../template/templateHook'
import { useTranslation } from 'react-i18next'
import nextArrow from '../../assets/small-next-white-icon.svg'
import Profile from '../../assets/profile'
import Watchlist from '../../assets/myWatchlist'
import Favorite from '../../assets/favorite'
// import Subscription from '../../assets/subscription'
// import Transaction from '../../assets/transaction'
// import ChangePlan from '../../assets/changePlan'
import HandBag from '../../assets/handBag'
import SignOut from '../../assets/signOut'
import Cart from '../../assets/cart'
import OrderHistory from '../../assets/orderHistory'
import Wishlist from '../../assets/wishlist'
import Address from '../../assets/address'
import { AppContext } from '../../context/app'
import { withTheme } from 'theming'

const MobileNavDropDown = ({
  theme,
  titleColor,
  borderTop,
  backgroundColor = 'transparent',
  isLeftAligned = false,
  useWhiteBorder = false,
  getStyleValue,
}) => {
  const { t } = useTranslation()
  const [selectedMenu, setSelectedMenu] = useState('main')
  const {
    logoutCall,
    // handleSubscription
  } = useTemplateHook()
  const { modulePermissions } = useContext(AppContext)

  const finalBorderTop = useWhiteBorder ? '1.5px solid white' : borderTop

  const justifyClass = isLeftAligned ? 'justify-start' : 'justify-center'

  // const paddingClass = isLeftAligned ? 'pl-5' : ''

  const paddingClassShop = isLeftAligned ? 'pl-12' : ''

  return (
    <div
      style={{
        backgroundColor: backgroundColor,
        borderRadius: '8px',
      }}
      className={`pb-5 pt-1`}
    >
      {selectedMenu === 'main' && (
        <ul className="" style={{ color: titleColor }}>
          <li style={{ padding: '9px 22px' }} className="font-semibold">
            <Link to="/profile" className={`flex items-center ${justifyClass} gap-2`}>
              <Profile height="13px" width="13px" />
              <p className="text-xs block px-2 cursor-pointer user-dropdown-menu">
                {t('my_profile')}
              </p>
            </Link>
          </li>

          <li
            style={{ borderTop: finalBorderTop, padding: '9px 22px' }}
            className="font-semibold py-[9px]"
          >
            <Link to="/watchlist" className={`flex ${justifyClass} items-center gap-2`}>
              <Watchlist height="13px" width="13px" />
              <p className="text-xs block px-2 cursor-pointer user-dropdown-menu ">
                {t('my_watchlist')}
              </p>
            </Link>
          </li>

          <li
            style={{ borderTop: finalBorderTop, padding: '9px 22px' }}
            className="font-semibold py-[9px]"
          >
            <Link to="/favourites" className={`flex ${justifyClass} items-center gap-2`}>
              <Favorite height="13px" width="13px" />
              <p className="text-xs block px-2 cursor-pointer user-dropdown-menu">
                {t('my_favorites')}
              </p>
            </Link>
          </li>

          {/* <li style={{ borderTop }} className="flex justify-center items-center font-semibold">
            <Link to="/subscriptions" className="flex items-center gap-2">
              <Subscription height="13px" width="13px" />
              <p className="text-xs block px-2 py-1 cursor-pointer user-dropdown-menu my-1">
                {t('my_subscriptions')}
              </p>
            </Link>
          </li>

          <li
            style={{ borderTop: finalBorderTop }}
            className={`flex ${justifyClass} ${paddingClass} items-center font-semibold`}
          >
            <Link to="/transactions" className="flex items-center gap-2">
              <Transaction height="13px" width="13px" />
              <p className="text-xs block px-2 py-1 cursor-pointer user-dropdown-menu my-1">
                {t('Transactions')}
              </p>
            </Link>
          </li>

          <li
            style={{ borderTop: finalBorderTop }}
            className={`flex ${justifyClass} ${paddingClass} items-center font-semibold`}
            onClick={handleSubscription}
          >
            <ChangePlan height="13px" width="13px" />
            <p className="text-xs block px-2 py-1 cursor-pointer user-dropdown-menu my-1">
              {t('change_plan')}
            </p>
          </li> */}

          {modulePermissions?.ecommerce ? (
            <li
              style={{ borderTop: finalBorderTop, padding: '9px 22px' }}
              className={`flex ${justifyClass} items-center font-semibold cursor-pointer`}
              onClick={() => setSelectedMenu('shop')}
            >
              <HandBag height="13px" width="13px" />
              <p className="text-xs block px-2 py-1 my-1">Shop</p>
              <img src={nextArrow} alt="arrow" className="w-4 h-4 ml-2" />
            </li>
          ) : null}

          <li
            style={{
              color: theme.c5,
              padding: '5px 22px',
            }}
            className="flex justify-center items-center mt-1"
          >
            <button
              onClick={logoutCall}
              style={{
                backgroundImage: `linear-gradient(to ${getStyleValue(
                  'add_btn2',
                  'gradient',
                  'right',
                )}, ${getStyleValue('add_btn2', 'primary_color', '#8e0000')}, ${getStyleValue(
                  'add_btn2',
                  'secondary_color',
                  '#ff0000',
                )})`,

                color: getStyleValue('add_btn2', 'text_color', theme.c6),
                borderRadius: '5px',
              }}
              className="border-0 shadow-xl font-medium  text-xs py-3 w-full flex items-center justify-center cursor-pointer"
            >
              <SignOut height="13px" width="13px" />
              <p className="px-2">{t('sign_out')}</p>
            </button>
          </li>
        </ul>
      )}

      {selectedMenu === 'shop' && (
        <ul className="" style={{ color: titleColor }}>
          <li
            style={{ borderTop: finalBorderTop }}
            className={`flex ${justifyClass}  items-center font-semibold cursor-pointer`}
            onClick={() => setSelectedMenu('main')}
          >
            <span className="px-2">←</span>
            <HandBag height="13px" width="13px" />
            <span className="text-xs block px-2 py-1 my-1">Shop</span>
          </li>

          <li
            style={{ borderTop: finalBorderTop }}
            className={`flex ${justifyClass} ${paddingClassShop} items-center font-semibold`}
          >
            <Link to="/cart-details" className="flex items-center gap-2">
              <Cart height="13px" width="13px" />
              <p className="text-xs block px-2 py-1 my-1">My Cart</p>
            </Link>
          </li>

          <li
            style={{ borderTop: finalBorderTop }}
            className={`flex ${justifyClass} ${paddingClassShop} items-center font-semibold`}
          >
            <Link to="/order-history" className="flex items-center gap-2">
              <OrderHistory height="13px" width="13px" />
              <p className="text-xs block px-2 py-1 my-1">Order History</p>
            </Link>
          </li>

          <li
            style={{ borderTop: finalBorderTop }}
            className={`flex ${justifyClass} ${paddingClassShop} items-center font-semibold`}
          >
            <Link to="/wish-list" className="flex items-center gap-2">
              <Wishlist height="13px" width="13px" />
              <p className="text-xs block px-2 py-1 my-1">Wishlist</p>
            </Link>
          </li>

          <li
            style={{ borderTop: finalBorderTop }}
            className={`flex ${justifyClass} ${paddingClassShop} items-center font-semibold`}
          >
            <Link to="/manage-address" className="flex items-center gap-2">
              <Address height="13px" width="13px" />
              <p className="text-xs block px-2 py-1 my-1">My Addresses</p>
            </Link>
          </li>
        </ul>
      )}
    </div>
  )
}

export default withTheme(MobileNavDropDown)
